let title = ' | Gestor - Comercial Ivaiporã'

const departamentoPessoal = {
    path: '/departamento-pessoal',
    props: true,
    component: () => import('@/Components/DP/ExportadorSenior/DepartamentoPessoalContainer.vue'),
    children: [
        {
            path: 'exportador-senior',
            props: true,
            name: 'DepartamentoPessoalExportadorSenior',
            component: () => import('@/Components/DP/ExportadorSenior/DepartamentoPessoalExportadorSenior.vue'),
            meta: {
                title: 'Exportador Sênior' + title,
                permission: 'dp_fechamento_folha_menu',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Turnover',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/departamento-pessoal',
                    },
                    {
                        text: 'Exportador Sênior',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '',
                    }
                ]
            }
        },
    ]
}

export default departamentoPessoal